/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reasonEnumSchema = z
	.enum(["request_waiter", "request_bill", "request_hookah"])
	.describe("* `request_waiter` - Вызов официанта\n* `request_bill` - Запрос счёта\n* `request_hookah` - Запрос кальяна");
